<template lang="pug">
.cadastro-section-label(:class="`cadastro-section-label--${variant}`")
  span.cadastro-section-label__text {{ label }}
  hr.cadastro-section-label__divider
</template>

<script>
export default {
  name: 'CadastroSectionLabel',
  props: {
    label: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: 'sm'
    }
  }
}
</script>

<style lang="scss" scoped>
.cadastro-section-label {
  align-items: center;
  display: flex;
  gap: 16px;
  width: 100%;

  &--md .cadastro-section-label__text {
    font-size: 14px;
    letter-spacing: 0.08em;
  }

  &--sm .cadastro-section-label__text {
    font-size: 11px;
    letter-spacing: 0.14em;
  }
}

.cadastro-section-label__text {
  color: #8a8a8a;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-weight: 500;
  line-height: 1.43;
  text-transform: uppercase;
  white-space: nowrap;

  .cadastro-section-label--md & {
    font-size: 14px;
    letter-spacing: 0.08em;
  }

  .cadastro-section-label--sm & {
    font-size: 11px;
    letter-spacing: 0.14em;
  }
}

.cadastro-section-label__divider {
  background: #eaeaea;
  border: 0;
  flex: 1;
  height: 1px;
  margin: 0;
}
</style>
